import { getProvisionalIdentifierForType } from '../util';
import { createError } from '../error';
import angular from 'angular';

class Task {
  serialize() {
    return null;
  }

  populate(data) {
  }

  persist() {
  }

  execute() {
    console.error("Task.execute() default implementation called");
    throw createError({
      error: 'TaskExecuteMissingImplementation',
      message: 'Task.execute() default implementation called; please override',
    });
  }

  get canExecute() {
    return false;
  }

  /**
   * Return array of [<object type>, <object id>] arrays corresponding to the list of
   * objects that will be updated by this task
   */
  get updatingObjectTypesAndIds() {
    return [];
  }
}

export default Task;
